<template>
  <div>
    <vs-prompt color="red" title="Suppression" @cancle="activeSuppression = false"
               @accept="activeSuppression = false, $vs.loading(), deleteData()" accept-text="OUI"
               @close="activeSuppression = false" :active.sync="activeSuppression">
      <div class="flex">
        <span>Etes-vous sûr de faire la suppression ?</span>
      </div>
    </vs-prompt>


    <vs-popup fullscreen title="MODIFIER"
              :active.sync="modifierotd">

      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <div style="margin-bottom: 10px !important;">
          <vs-button class="mr-6" @click="updateData">Valider</vs-button>
          <vs-button type="border" color="danger" @click="modifierotd = false">Annuler</vs-button>
        </div>
        <vs-divider style="height: 5px" background="primary"></vs-divider>

        <div style="margin: 10px !important;" class="row">
          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            Titre
          </vs-col>

          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            Catégorie
          </vs-col>

          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            Autoriser les commentaires
          </vs-col>

          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-input @keyup.enter="updateData" v-model="input.title" class="w-full" name="title"
                      :danger="!!formErrors.title"
                      :danger-text="formErrors.title ? formErrors.title[0] : ''" v-on:input="resetErrors('title')"/>
          </vs-col>

          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-row>
              <v-select class="w-full" label="name" v-model="input.category_subject" :options="categories"></v-select>

              <vs-col>
                <span style="font-size: 0.65rem !important;" class="text-danger text-sm" v-if="formErrors.category">{{ formErrors.category[0] }}</span>
              </vs-col>
            </vs-row>
          </vs-col>

          <vs-col class="kijinput" vs-type="flex" vs-justify="left" vs-align="left" vs-w="4">
            <vs-switch v-model="input.alert"/>
          </vs-col>

          <vs-tabs>
            <vs-tab label="Votre Sujet">
              <div>
                <quill-editor v-model="input.description"></quill-editor>
              </div>
            </vs-tab>
          </vs-tabs>

          <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-button class="mr-6" color="white"></vs-button>
          </vs-col>
          <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-button class="mr-6" color="white"></vs-button>
          </vs-col>
          <vs-col class="kijinput" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-button class="mr-6" color="white"></vs-button>
          </vs-col>
        </div>
      </VuePerfectScrollbar>


    </vs-popup>


    <div class="vx-row">
      <!-- COL 1 -->
      <div class="vx-col w-full lg:w-2/3">

        <div class="uuuuuuuuuuuuuuuuuuuuu">
          <div>
            <div class="post-header flex justify-between mb-4">

              <div class="flex items-center">

                <div class="ml-4">
                  <h1 style="font-size: 24px;  font-weight: 600;   margin-top: 0;">TOUS LES SUJETS ({{subjects.length}})</h1>
                </div>
              </div>
            </div>

            <vs-divider style="height: 2px" background="primary"></vs-divider>

            <div v-if="subjects && subjects.length">
              <div v-for="(item, uio) in subjects" :key="item.slug">
                <div class="post-header flex justify-between mb-4">
                  <div class="flex items-center">
                    <div>
                      <vs-avatar class="m-0" :src="$store.state.AppActiveUser.photoURL" size="45px"></vs-avatar>
                    </div>
                    <div class="ml-4">
                      <router-link :to="'/forum/show/user/'+item.user.id">{{ item.user ? item.user.lastname + " "+ item.user.firstname : '' }}
                      </router-link>
                      - <small>{{ duration(item.created_at)}}</small>
                    </div>
                  </div>
                </div>

                <div class="post-content contentOTDS">
                  <h4 style="text-transform:uppercase;"><router-link :to="'/forum/show/'+item.slug">{{item.title }}</router-link>&nbsp; <small style="#818181">{{'('+item.comments.length + ' réponses)'}}</small></h4>
                  <vs-divider style="height: 2px" background="primary"></vs-divider>
                  <p v-html="item.description"></p>
                  <feather-icon v-if="item.user_id === $store.state.AppActiveUser.id" style="color: green"
                                icon="EditIcon"
                                svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2"
                                @click.stop="input = JSON.parse(JSON.stringify(item)), comment1 = input.comment, modifierotd = true"/>
                  <feather-icon v-if="item.user_id === $store.state.AppActiveUser.id" style="color: red"
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                                @click.stop="activeSuppression = true, itemSupprimer = item.slug"/>
                </div>
                <vs-divider v-if="uio !== (comments.length - 1)" size="20" style="height: 1px"
                            background="primary"></vs-divider>
              </div>
            </div>
            <div class="ml-4" v-else>
              <h3 style="font-size: 18px;  font-weight: 600;   margin-top: 0;">Aucun sujet à afficher</h3>
            </div>
          </div>
        </div>

      </div>

      <div class="vx-col w-full lg:w-1/3">
        <div class="ddddddddd">
          <vs-list>
            <vs-list-header title="FILTRE" color="primary"></vs-list-header>
            <vs-button class="w-full" color="primary" @click="$router.push({path: '/forum/all'})" type="border">TOUS LES
              SUJETS
            </vs-button>
            &nbsp;
            <vs-button class="w-full" color="primary" @click="getMySubjects" type="border">MES SUJETS</vs-button>
          </vs-list>
        </div>
        <div class="ddddddddd">
          <vs-list>
            <vs-list-header title="CATÉGORIES" color="primary"></vs-list-header>
            <div>

              <vs-list>
                <vs-list-item style="cursor: pointer" v-for="item in categories"
                              :key="item.slug" :title="item.name">
                  <router-link :to="'/forum/show/category/'+item.slug"><vs-chip color="primary">{{item.subjects.length}}</vs-chip></router-link>
                </vs-list-item>
              </vs-list>
            </div>
          </vs-list>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {_buildQuery} from "../../../helpers/buildquery";

  var base_self;
  var input_tempon = {
    title: '',
    alert: true,
    description: '',
    category_subject_id: '',
  }

  export default {
    name: 'principalSubjects',
    props: {
      base: ''
    },
    components: {},
    watch: {
      category() {
        base_self.getDatas()
      },
      messujets() {
        base_self.getDatas()
      },
      '$route.params.category': function () {
        if (this.$route.params.category){
          this.getSubjectsByCategory()
        }
      }
    },
    data() {
      return {
        activeSuppression: false,
        itemSupprimer: '',
        comment: '',
        comment1: '',
        modifierotd: false,
        input: {
          title: '',

        },
        messujets: false,
        comments: [],
        datas: [],
        category: [],
        categories: [],
        url: '/forum/subjects',
        datas_second: [],
        settings: {
          maxScrollbarLength: 600,
          wheelSpeed: 0.6
        },
        videoUrl: 'http://vjs.zencdn.net/v/oceans.mp4',
        subjects: [],
        formErrors: {}
      };
    },
    computed: {
      isAdmin() {
        return window.getApp.isAdmin();
      },
      media() {
        var ok = window.subject.media && window.subject.media.type_media && (window.subject.media.type_media.slug === 'video')
        var videoUrl = (ok && window.subject.media.path) ? window.getApp.getUrlForImageOrVideo(window.subject.media.path) : base_self.videoUrl;
        return {
          sources: [{type: "video/" + (videoUrl.split('.'))[(videoUrl.split('.')).length - 1], src: videoUrl}],
          /* sources: [{ type: "video/mp4", src: videoUrl }], */
          poster: 'https://goo.gl/xcCsDd'
        }
      },
      playerOptions() {
        return (media) => {
          return {
            height: '360',
            fluid: true,
            autoplay: true,
            muted: false,
            language: 'fr',
            playbackRates: [0.7, 1.0, 1.5, 2.0],
            sources: media.sources,
            poster: media.poster,
          }
        }
      },
      getApp() {
        return window.getApp
      },
      realBase() {
        return base_self
      }
    },
    methods: {
      initInput() {
        base_self.input = JSON.parse(JSON.stringify(input_tempon))
      },
      inputInitialize() {
        this.formErrors = {};
        (base_self.modifierotd) ? (base_self.input = JSON.parse(JSON.stringify(base_self.base.item))) : base_self.initInput()

        base_self.input.category_subject_id = base_self.input.category_subject ? base_self.input.category_subject : ''
      },
      duration(date) {
        const value = moment(date)
        value.locale('fr')
        return value.fromNow()
      },

      updateData() {
        // console.log('base_self.input: ', base_self.input)
        var input = JSON.parse(JSON.stringify(base_self.input))
        input.category = base_self.input.category_subject_id ? base_self.input.category_subject.id : ''

        base_self.$vs.loading()

        base_self.$http.put('/forum/subjects/' + base_self.input.slug, input)
          .then((response) => {
            window.getApp.success("Le sujet a été modifié avec succès.", response);
            base_self.modifierotd = false;
            base_self.initInput();
            base_self.getSubjectsByCategory()
            base_self.getCategories()
          })
          .catch((error) => {
            base_self.$vs.loading.close()
            this.$vs.notify({
              title: 'Erreur',
              text: 'Veuilliez valider les champs du formulaire',
              color: 'danger',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
            // console.log(error.response.data.status_code)
            if (error.response.data.status_code === 422) {
              this.formErrors = error.response.data.errors
            }
          })
      },
      deleteData() {
        base_self.$vs.loading()

        base_self.$http.delete('/forum/subjects/' + base_self.itemSupprimer)
          .then((response) => {
            window.getApp.success("Le sujet a été supprimé avec succès.", response);
            base_self.comment1 = '';
            base_self.getSubjectsByCategory()
            base_self.getCategories()
          })
          .catch((error) => {
            window.getApp.error(error)
          })
      },

      getCategories() {
        base_self.$http.get('/categories/subjects').then(response => {
          base_self.categories = response.data.data;
        })
      },
      getList() {
        base_self.$vs.loading()
        base_self.$http.get(base_self.url)
          .then((response) => {
            base_self.$vs.loading.close();
            base_self.datas_second = response.data.data;
            base_self.getDatas()
          })
          .catch((error) => {
            window.getApp.error(error)
          })
      },

      getSubjectsByCategory() {
        //alert(1)
        let params = {
          user: this.$route.params.user ? this.$route.params.user : '',
          category: this.$route.params.category ? this.$route.params.category : '',
        }
        base_self.$http.get(base_self.url)
          .then((response) => {
            base_self.subjects = response.data.data
          })
          .catch((error) => {
            base_self.$vs.loading.close()
            this.$vs.notify({
              title: 'Erreur',
              text: "Something went wrong",
              color: 'danger',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })

          })
      },

      getMySubjects(){
        const user_id = JSON.parse(localStorage.getItem('userInfo')).id;
        this.$router.push({path: '/forum/show/user/'+user_id}).catch(()=>{})
      },

      resetErrors(field) {
        if (field) {
          this.formErrors[field] = null;
        } else {
          this.formErrors = [];
          Object.keys(this.input).forEach(index => this.input[index] = null);
        }
      },
    },
    created() {
      base_self = this
    },
    destroyed: function () {
      window.subject = '';
    },
    mounted() {
      base_self.getList()
      base_self.getCategories()
      base_self.getSubjectsByCategory()
      base_self.inputInitialize()
    }
  };
</script>

<style>
  .ddddddddd {
    background-color: white;
    border: 1px solid #c1c1c1;
    border-radius: 5px 5px;
    margin: 5px;
  }

  .uuuuuuuuuuuuuuuuuuuuu {
    background-color: white;
    border: 1px solid #c1c1c1;
    border-radius: 5px 5px;
    margin: 5px;
    padding: 10px;
  }

  .contentOTD {
    border: 2px solid #c1c1c1;
    border-radius: 20px 0px 20px 0px;
    padding: 20px;
    background-color: #eaf1ff;
  }

  .contentOTDS {
    border: 2px solid #c1c1c1;
    border-radius: 0px 20px 0px 20px;
    padding: 20px;
    background-color: #ffffff;
  }
</style>
